import { useTheme } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import MuiPaper, { PaperProps as MuiPaperProps } from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React from "react";

type PaperChartProps = MuiPaperProps & {
  label?: string;
  loading?: boolean;
  children?: React.ReactNode;
};

export function PaperChart({
  loading,
  children,
  label,
  ...rest
}: PaperChartProps) {
  const theme = useTheme();
  return (
    <MuiPaper {...rest}>
      {label && (
        <Typography marginBottom={2} variant="h6" color="primary">
          {label}
        </Typography>
      )}
      {loading ? (
        <Stack justifyContent="center" alignItems="center">
          <CircularProgress size={theme.typography.h5.fontSize} thickness={4} />
        </Stack>
      ) : (
        children
      )}
    </MuiPaper>
  );
}
